import {
  REQUEST_INVENTORIES,
  FETCH_INVENTORIES_SUCCESS,
  FETCH_INVENTORIES_FAILURE,
  REQUEST_SALES_ORDER_INVENTORY,
  FETCH_SALES_ORDER_INVENTORY_SUCCESS,
  FETCH_SALES_ORDER_INVENTORY_FAILURE,
  REQUEST_DETAILED_INVENTORIES,
  FETCH_DETAILED_INVENTORIES_SUCCESS,
  FETCH_DETAILED_INVENTORIES_FAILURE,
  CLEAR_INVENTORIES,
  SELECT_INVENTORY,
  RESET_CURRENT_INVENTORY,
  REQUEST_INVENTORY_DETAIL,
  FETCH_INVENTORY_DETAIL_SUCCESS,
  FETCH_INVENTORY_DETAIL_FAILURE,
  REQUEST_LOW_STOCK_INVENTORIES,
  FETCH_LOW_STOCK_INVENTORIES_SUCCESS,
  FETCH_LOW_STOCK_INVENTORIES_FAILURE,
  REQUEST_EXPIRED_INVENTORIES,
  FETCH_EXPIRED_INVENTORIES_SUCCESS,
  FETCH_EXPIRED_INVENTORIES_FAILURE,
  REQUEST_INVENTORIES_BY_GROUP,
  REQUEST_INVENTORIES_BY_GROUP_SUCCESS,
  REQUEST_INVENTORIES_BY_GROUP_FAILURE,
  REQUEST_INVENTORIES_BY_CATEGORY,
  REQUEST_INVENTORIES_BY_CATEGORY_SUCCESS,
  REQUEST_INVENTORIES_BY_CATEGORY_FAILURE,
  REQUEST_INVENTORIES_BY_PERIOD,
  FETCH_INVENTORIES_BY_PERIOD_SUCCESS,
  FETCH_INVENTORIES_BY_PERIOD_FAILURE,
  SET_ORIGIN_PAGE,
  REQUEST_NONZERO_INVENTORIES,
  FETCH_NONZERO_INVENTORIES_SUCCESS,
  FETCH_NONZERO_INVENTORIES_FAILURE,
  REQUEST_LOW_INVENTORIES,
  FETCH_LOW_INVENTORIES_SUCCESS,
  FETCH_LOW_INVENTORIES_FAILURE,
  REQUEST_WORKING_ORDERS,
  FETCH_WORKING_ORDERS_SUCCESS,
  FETCH_WORKING_ORDERS_FAILURE,
  FETCH_INVENTORY_HISTORY,
  FETCH_INVENTORY_HISTORY_SUCCESS,
  FETCH_INVENTORY_HISTORY_FAILURE,
} from '../actions/type';

const INITIAL_STATE = {
  all: [],
  currentInventory: null,
  currentInventoryDetail: null,
  isLoading: false,
  error: null,
  detailIsLoading: false,
  detailError: null,
  isCreating: false,
  createError: null,
  created: false,
  isEditing: false,
  editError: null,
  edited: false,
  lowStockInventories: null,
  lowStockError: null,
  lowStockIsLoading: false,
  expiredInventories: null,
  expiredError: null,
  expiredIsLoading: false,
  detailedInventories: [],
  detailedInventoriesIsLoading: false,
  detailedInventoriesError: null,
  salesOrderInventory: [],
  salesOrderInventoryIsLoading: false,
  salesOrderInventoryError: null,
  inventoriesByGroupIsLoading: false,
  inventoriesByGroup: [],
  inventoriesByGroupError: null,
  inventoriesByCategoryIsLoading: false,
  inventoriesByCategory: [],
  inventoriesByCategoryError: null,
  inventoriesByPeriod: null,
  inventoriesByPeriodIsLoading: false,
  inventoriesByPeriodError: null,
  originPage: null,
  nonZeroInventories: [],
  nonZeroInventoriesIsLoading: false,
  nonZeroInventoriesError: null,
  lowInventoriesIsLoading: false,
  lowInventories: null,
  lowInventoriesError: null,
  workingOrdersIsLoading: false,
  workingOrders: null,
  workingOrdersError: null,
  inventoryHistory: [],
  inventoryHistoryIsLoading: false,
  inventoryHistoryError: null,
};


export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    // Inventory action handlers
    case REQUEST_INVENTORIES:
      return {
        ...state, all: null, error: null, isLoading: true,
      };
    case FETCH_INVENTORIES_SUCCESS:
      return {
        ...state, all: action.payload.data, error: null, isLoading: false,
      };
    case FETCH_INVENTORIES_FAILURE:
      const error = action.payload || { message: action.payload.message };
      return {
        ...state, all: null, error, isLoading: false,
      };
    case CLEAR_INVENTORIES:
      return {
        ...state, all: null, error: null, isLoading: false,
      };
    case REQUEST_LOW_STOCK_INVENTORIES:
      return {
        ...state, all: null, lowStockError: null, lowStockIsLoading: true,
      };
    case FETCH_LOW_STOCK_INVENTORIES_SUCCESS:
      return {
        ...state, lowStockInventories: action.payload.data, lowStockError: null, lowStockIsLoading: false,
      };
    case FETCH_LOW_STOCK_INVENTORIES_FAILURE:
      const lowStockError = action.payload || { message: action.payload.message };
      return {
        ...state, lowStockInventories: [], lowStockError, lowStockIsLoading: false,
      };
    case REQUEST_EXPIRED_INVENTORIES:
      return {
        ...state, all: null, expiredError: null, expiredIsLoading: true,
      };
    case FETCH_EXPIRED_INVENTORIES_SUCCESS:
      return {
        ...state, expiredInventories: action.payload.data, expiredError: null, expiredIsLoading: false,
      };
    case FETCH_EXPIRED_INVENTORIES_FAILURE:
      const expiredError = action.payload || { message: action.payload.message };
      return {
        ...state, expiredInventories: [], expiredError, expiredIsLoading: false,
      };
    case SELECT_INVENTORY:
      return { ...state, currentInventory: action.payload };
    case RESET_CURRENT_INVENTORY:
      return { ...state, currentInventory: null };
    case REQUEST_INVENTORY_DETAIL:
      return { ...state, detailError: null, detailIsLoading: true };
    case FETCH_INVENTORY_DETAIL_SUCCESS:// return list of posts and make loading = false
      return {
        ...state, currentInventoryDetail: action.payload.data, detailError: null, detailIsLoading: false,
      };
    case FETCH_INVENTORY_DETAIL_FAILURE:// return error and make loading = false
      const detailError = action.payload || { message: action.payload.message };// 2nd one is network or server down errors
      return {
        ...state, all: [], detailError, detailIsLoading: false,
      };
    case REQUEST_DETAILED_INVENTORIES:
      return {
        ...state, detailedInventoriesIsLoading: true, detailedInventories: [], detailedInventoriesError: null,
      };
    case FETCH_DETAILED_INVENTORIES_SUCCESS:
      return { ...state, detailedInventoriesIsLoading: false, detailedInventories: action.payload.data };
    case FETCH_DETAILED_INVENTORIES_FAILURE:
      const detailedInventoriesError = action.payload.data || { message: action.payload.message };
      return { ...state, detailedInventoriesIsLoading: false, detailedInventoriesError };
    case REQUEST_SALES_ORDER_INVENTORY:
      return {
        ...state, salesOrderInventoryIsLoading: true, salesOrderInventoryError: null, salesOrderInventory: [],
      };
    case FETCH_SALES_ORDER_INVENTORY_SUCCESS:
      return { ...state, salesOrderInventoryIsLoading: false, salesOrderInventory: action.payload.data };
    case FETCH_SALES_ORDER_INVENTORY_FAILURE:
      const salesOrderInventoryError = action.payload.data || { message: action.payload.message };
      return { ...state, salesOrderInventoryIsLoading: false, salesOrderInventoryError };


    case REQUEST_INVENTORIES_BY_GROUP:
      return {
        ...state, inventoriesByGroupIsLoading: true, inventoriesByGroup: [], inventoriesByGroupError: null,
      };
    case REQUEST_INVENTORIES_BY_GROUP_SUCCESS:
      return { ...state, inventoriesByGroupIsLoading: false, inventoriesByGroup: action.payload.data };
    case REQUEST_INVENTORIES_BY_GROUP_FAILURE:
      const inventoriesByGroupError = action.payload.data || { message: action.payload.message };
      return { ...state, inventoriesByGroupIsLoading: false, inventoriesByGroupError };
    case REQUEST_INVENTORIES_BY_CATEGORY:
      return {
        ...state, inventoriesByCategoryIsLoading: true, inventoriesByCategory: [], inventoriesByCategoryError: null,
      };
    case REQUEST_INVENTORIES_BY_CATEGORY_SUCCESS:
      return { ...state, inventoriesByCategoryIsLoading: false, inventoriesByCategory: action.payload.data };
    case REQUEST_INVENTORIES_BY_CATEGORY_FAILURE:
      const inventoriesByCategoryError = action.payload.data || { message: action.payload.message };
      return { ...state, inventoriesByCategoryIsLoading: false, inventoriesByCategoryError };
    case REQUEST_INVENTORIES_BY_PERIOD:
      return {
        ...state, inventoriesByPeriodIsLoading: true, inventoriesByPeriod: null, inventoriesByPeriodError: null,
      };
    case FETCH_INVENTORIES_BY_PERIOD_SUCCESS:
      return { ...state, inventoriesByPeriodIsLoading: false, inventoriesByPeriod: action.payload.data };
    case FETCH_INVENTORIES_BY_PERIOD_FAILURE:
      const inventoriesByPeriodError = action.payload.data || { message: action.payload.message };
      alert(JSON.stringify(inventoriesByPeriodError));
      return { ...state, inventoriesByPeriodIsLoading: false, inventoriesByPeriodError };
    case REQUEST_NONZERO_INVENTORIES:
      return {
        ...state, nonZeroInventoriesIsLoading: true, nonZeroInventories: [], nonZeroInventoriesError: null,
      };
    case FETCH_NONZERO_INVENTORIES_SUCCESS:
      return { ...state, nonZeroInventoriesIsLoading: false, nonZeroInventories: action.payload.data };
    case FETCH_NONZERO_INVENTORIES_FAILURE:
      const nonZeroInventoriesError = action.payload.data || { message: action.payload.message };
      return { ...state, nonZeroInventoriesIsLoading: false, nonZeroInventoriesError };

    case SET_ORIGIN_PAGE:
      return { ...state, originPage: action.payload };
    case REQUEST_LOW_INVENTORIES:
      return {
        ...state, lowInventoriesIsLoading: true, lowInventories: null, lowInventoriesError: null,
      };
    case FETCH_LOW_INVENTORIES_SUCCESS:
      return {
        ...state, lowInventoriesIsLoading: false, lowInventories: action.payload.data, lowInventoriesError: null,
      };
    case FETCH_LOW_INVENTORIES_FAILURE:
      const lowInventoriesError = action.payload.data || { message: action.payload.message };
      return {
        ...state, lowInventoriesIsLoading: false, lowInventories: null, lowInventoriesError,
      };

    case REQUEST_WORKING_ORDERS:
      return {
        ...state, workingOrdersIsLoading: true, workingOrders: null, workingOrdersError: null,
      };
    case FETCH_WORKING_ORDERS_SUCCESS:
      return {
        ...state, workingOrdersIsLoading: false, workingOrders: action.payload.data, workingOrdersError: null,
      };
    case FETCH_WORKING_ORDERS_FAILURE:
      const workingOrdersError = action.payload.data || { message: action.payload.message };
      return {
        ...state, workingOrdersIsLoading: false, workingOrders: null, workingOrdersError,
      };

    case FETCH_INVENTORY_HISTORY:
      return {
        ...state, inventoryHistoryIsLoading: true, inventoryHistory: null, inventoryHistoryError: null,
      };
    case FETCH_INVENTORY_HISTORY_SUCCESS:
      return {
        ...state, inventoryHistoryIsLoading: false, inventoryHistory: action.payload.data, inventoryHistoryError: null,
      };
    case FETCH_INVENTORY_HISTORY_FAILURE:
      const inventoryHistoryError = action.payload.data || { message: action.payload.message };
      return {
        ...state, inventoryHistoryIsLoading: false, inventoryHistory: null, inventoryHistoryError,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/inventories_reducer.js